// extracted by mini-css-extract-plugin
module.exports = {"modal-item-rate":"ModalRateItem_modal-item-rate__l9WEp","rate-item-title-wrapper":"ModalRateItem_rate-item-title-wrapper__QVOt5"};